define('components/charts/loaders/piechart',[
    'components/charts/common',
    'components/charts/tooltip',
    'components/strings',
    'google_charts!corechart'
], function(common, tooltip, stringsComponent) {
    var DEFAULT_FONT_SIZE = 12,
        DEFAULT_PIE_HOLE_SIZE = 0.4;
    var loader = function($container) {
        var data = parseData($container);
        var options = parseOptions($container);
        var chart = new google.visualization.PieChart($container[0]);
        var datatable = createDataTable(data);
        registerTooltip($container, chart, data, datatable);
        var chartOptions = determineChartOptions(options, data);
        return {
            instance: chart,
            shouldRedrawOnWindowResize: true,
            draw: function() {
                chart.draw(datatable, chartOptions);
            },
            redraw: function() {
                // Must re-instantiate chart object to work around a bug where the
                // labels are not places at the appropriate location when the chart
                // container was display:none on initialization.
                // See https://github.com/google/google-visualization-issues/issues/1170
                chart = new google.visualization.PieChart($container[0]);
                registerTooltip($container, chart, data, datatable);
                chart.draw(datatable, chartOptions);
            }
        };
    };


    /**
    `json` should be: [
        // Required
        {
            sliceLabel: '',
            percentage: 50, // From 0 to 100
            fontSize: 10, // Optional
        },
        ...
    }
    **/
    function parseData($container) {
        // NOTE: `.data()` will automatically convert to a JS object.
        return $container.data('json').map(function (x) {
            x._htmlEscapedSliceLabel = stringsComponent.escapeHtml(x.sliceLabel);
            return x;
        });
    }

    function parseOptions($container) {
        // NOTE: `.data()` will automatically convert to a JS object.
        var options = $container.data('options');
        if (typeof options == 'undefined') {
            options = {};
        }
        return options;
    }

    function determineChartOptions(templateOptions, data) {
        var pieSliceTextStyle = {};
        if ('pieSliceTextStyle' in templateOptions) {
            pieSliceTextStyle = templateOptions.pieSliceTextStyle;
        }
        pieSliceTextStyle.color = data.length > 1 ? '#F9F9F9' : '#333';

        var options = {
            legend: {
                position: 'right',
                alignment: 'top',
            },
            sliceVisibilityThreshold: templateOptions.sliceVisibilityThreshold || 0, // 'Other' label
            pieSliceText: templateOptions.pieSliceText || 'percentage',
            fontName: templateOptions.fontName || common.fontName,
            fontSize: parseInt(templateOptions.fontSize, 10) || DEFAULT_FONT_SIZE,
            tooltip: {
                trigger: 'none'
            },
            slices: {}, // populated below
            chartArea: {
                width: '100%',
                height: '100%',
            },
            pieHole: templateOptions.pieHole || DEFAULT_PIE_HOLE_SIZE,
            enableInteractivity: false,
            pieSliceTextStyle: pieSliceTextStyle,
        };

        
        var i = 0;
        var unknownIndex = -1;
        var UNKNOWN_COLOR = common.colors.piechartUnknownColor;
        var piechartColors = common.colors.piechartPalette.slice();
        var countColors = piechartColors.length;
        var lastColor = null;
        for (; i < countColors; i++) {
            if (data[i] && data[i].sliceLabel == 'Unknown') {
                unknownIndex = i;
                options.slices[i] = {color: UNKNOWN_COLOR};
            } else {
                lastColor = piechartColors.shift() || lastColor;
                options.slices[i] = {color: lastColor};
            }
        }
        if (unknownIndex < 0) {
            for (; i < data.length; i++) {
                if (data[i] && data[i].sliceLabel == 'Unknown') {
                    unknownIndex = i;
                    options.slices[i] = {color: UNKNOWN_COLOR};
                }
            }
        }

        return options;
    }


    function createDataTable(data) {
        var datatable = new google.visualization.DataTable();
        datatable.addColumn({label:'Category', type:'string'});
        datatable.addColumn({label:'Percentage', type:'number'});
        datatable.addRows(data.map(function(x) {
            return [
                // NOTE: Piechart labels are automatically HTML-escaped.
                {v: x._htmlEscapedSliceLabel, f:x.sliceLabel},
                x.percentage
            ];
        }));
        return datatable;
    }

    /*
    If a slice's label is too large to fit entirely within the slice,
    Google's implementation annoyingly hides the entire label
    instead of using an ellipsis like `text-overflow: ellipsis` in css;
    so we are forced to ellide the labels manually.
    */
    function ellideLabels(label) {
        var MAX_CHARACTERS = 10;
        var ELLIPSIS = '…';
        if (label.length > MAX_CHARACTERS) {
            return label.substring(0, MAX_CHARACTERS - 1) + ELLIPSIS
        }
        return label;
    }

    function registerTooltip($container, chart, data, datatable) {
        tooltip.setTooltipHandler(chart, {
            onlyHoverOnDataPoints: false,
            handler: function(row) {
                var layout = chart.getChartLayoutInterface();
                var bbox = layout.getBoundingBox('slice#' + row);
                var tooltipTitle = datatable.getValue(row, 0);
                var percentage = datatable.getValue(row, 1);
                var tooltipBody = '<div class="text-center">' + common.percentageFormat.formatValue(percentage) + '</div>';
                
                var offset = $container.offset();
                return {
                    title: tooltipTitle,
                    body: tooltipBody,
                    targetX: offset.left + bbox.left + bbox.width/2,
                    targetY: offset.top + bbox.top + bbox.height/2
                };
            }
        });
    }

    return loader;
});

